import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { User } from 'src/app/common/state/user/user.model';
import { select } from 'src/app/common/utilities/ngxs-utils';
import { Subscription, take, map } from 'rxjs';
import { CoachingLogService } from '../../services/coaching-log/coaching-log.service';
import { WysiwygEditorConfig } from '../wysiwyg-editor/wysiwyg-editor.component';
import { CoachingLogState } from '../../state/coaching-log/coaching-log.state';
import { CoachingSessionDTO } from '../../dtos/coaching-session.dto';

@Component({
  selector: 'app-coaching-log-notes',
  templateUrl: './coaching-log-notes.component.html',
  styleUrls: ['./coaching-log-notes.component.scss'],
})
export class CoachingLogNotesComponent implements OnInit, OnDestroy {
  @Input() user: User | null;

  @Input() notesActive: boolean;

  @Input() sessionId: number;

  @Output() hideNotesEvent = new EventEmitter<boolean>();

  initialContent: string;

  notesSaving = false;

  notes = '';

  sessionData$ = select(CoachingLogState.getSessionData);

  sessionData: CoachingSessionDTO | null;

  subs: Subscription[] = [];

  config: WysiwygEditorConfig = {
    useCodox: true,
    width: 340,
    height: 240,
  };

  constructor(public coachingService: CoachingLogService) {}

  hideNotes() {
    this.hideNotesEvent.emit(true);
  }

  updateNotes(notes: string) {
    this.notesSaving = true;
    this.coachingService.updateNotes(this.sessionId, notes);
    this.initialContent = notes;
  }

  ngOnInit(): void {
    this.config.editId = `log${this.sessionId}notes`;
    this.subs.push(
      this.sessionData$
        .pipe(map((filterFn) => filterFn(this.sessionId)))
        .subscribe((sessionData) => {
          this.notesSaving = false;
          this.sessionData = sessionData;
        })
    );
    this.subs.push(
      this.sessionData$
        .pipe(
          map((filterFn) => filterFn(this.sessionId)),
          take(1)
        )
        .subscribe((sessionData) => {
          this.initialContent = sessionData?.sessionNotes || '';
        })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
